import { render, staticRenderFns } from "./SupportContractModalForm.vue?vue&type=template&id=51275863"
import script from "./SupportContractModalForm.vue?vue&type=script&lang=js"
export * from "./SupportContractModalForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports